import { useTheme } from '@mui/material';

import { partyShade } from './partyPalette';

const lightChartColors = [
  '#190F41',
  '#C76A00',
  '#007C91',
  '#D64545',
  '#4F9A2A',
  '#2A7FD1',
  '#9A8400',
  '#D63D7A',
  '#A95F0A',
  '#1B8D7F',
  '#6F63C8',
  '#8B6F2A',
  '#305823',
  '#00549F',
  '#7E1024',
  '#D05A78',
  '#008F7A',
  '#7A4EC4',
  '#C01E62',
  '#5C8F2A',
] as const;

const darkChartColors = [
  '#8F7CFF',
  '#F89728',
  '#08A4BD',
  '#FF5F5F',
  '#7FD258',
  '#5FBCFF',
  '#FFE870',
  '#FB66A5',
  '#FFB86B',
  '#4DD4C6',
  '#B6A7F3',
  '#F0DEAE',
  '#9FE870',
  '#3D8BFF',
  '#FF6F91',
  '#FFA0B1',
  '#61EDD0',
  '#A47CFF',
  '#FF5CA8',
  '#CDFFBC',
] as const;

export function useColors() {
  const {
    palette: {
      background,
      partyBackground,
      common,
      error,
      primary,
      grey,
      success,
      warning,
      secondary,
      text,
      mode = 'light',
      muted,
      surface,
      surfaceHover,
      border,
    },
  } = useTheme();

  const chartColors = partyBackground
    ? darkChartColors.map((_, index) => partyShade(partyBackground, 0.3 + index * 0.033))
    : mode === 'dark'
      ? darkChartColors
      : lightChartColors;

  return {
    backgroundGrey: background.paper,
    black: text.primary,
    ink: common.black,
    border,
    chartColors,
    darkGrey: text.secondary,
    error: error.main,
    errorDark: error.dark,
    errorLight: error.light,
    grey: grey[500],
    greyLight: grey[200],
    greyMedium: grey[400],
    primary: primary.main,
    primaryDark: primary.dark,
    primaryLight: primary.light,
    secondary: secondary.main,
    secondaryLight: secondary.light,
    success: success.main,
    successLight: success.light,
    muted,
    surface,
    surfaceHover,
    textPrimary: text.primary,
    textSecondary: text.secondary,
    textDisabled: text.disabled,
    warning: warning.main,
    warningLight: warning.light,
    white: common.white,
    mode,
  } as const;
}
